// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";

const DAYS = [
  { key: "mon", label: "Montag" },
  { key: "tue", label: "Dienstag" },
  { key: "wed", label: "Mittwoch" },
  { key: "thu", label: "Donnerstag" },
  { key: "fri", label: "Freitag" },
  { key: "sat", label: "Samstag" },
  { key: "sun", label: "Sonntag" },
];

const DEFAULT_DAY = { closed: true, open: "", close: "" };

export const operatingHoursToState = (json) => {
  const out = {};
  for (const { key } of DAYS) {
    const v = json && typeof json === "object" ? json[key] : null;
    if (!v || v.closed || (!v.open && !v.close)) {
      out[key] = { ...DEFAULT_DAY };
    } else {
      out[key] = {
        closed: false,
        open: v.open ?? "",
        close: v.close ?? "",
      };
    }
  }
  return out;
};

export const operatingHoursFromState = (state) => {
  const out = {};
  for (const { key } of DAYS) {
    const v = state?.[key];
    if (v && !v.closed && v.open && v.close) {
      out[key] = { open: v.open, close: v.close };
    }
  }
  return Object.keys(out).length > 0 ? out : null;
};

const OperatingHoursEditor = ({ value, onChange, disabled = false }) => {
  const state =
    value && typeof value === "object" ? value : operatingHoursToState(null);

  const patchDay = (dayKey, patch) => {
    onChange({
      ...state,
      [dayKey]: { ...(state[dayKey] || DEFAULT_DAY), ...patch },
    });
  };

  return (
    <div className="space-y-2">
      {DAYS.map(({ key, label }) => {
        const day = state[key] || DEFAULT_DAY;
        const isClosed = !!day.closed;
        return (
          <div
            key={key}
            className="flex flex-wrap items-center gap-3 px-3 py-2 rounded-lg border border-gray-200 dark:border-slate-600 bg-white dark:bg-slate-700/50"
          >
            <span className="w-24 shrink-0 text-sm font-medium text-gray-700 dark:text-slate-300">
              {label}
            </span>
            <label className="inline-flex items-center gap-1.5 text-sm text-gray-600 dark:text-slate-400 cursor-pointer">
              <input
                type="checkbox"
                checked={isClosed}
                disabled={disabled}
                onChange={(e) => patchDay(key, { closed: e.target.checked })}
                className="w-4 h-4 rounded border-gray-300 dark:border-slate-600 text-primary-color focus:ring-primary-color"
              />
              Geschlossen
            </label>
            <input
              type="time"
              value={day.open || ""}
              disabled={disabled || isClosed}
              onChange={(e) => patchDay(key, { open: e.target.value })}
              className="px-2 py-1.5 border border-gray-300 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed"
            />
            <span className="text-sm text-gray-500 dark:text-slate-400">
              bis
            </span>
            <input
              type="time"
              value={day.close || ""}
              disabled={disabled || isClosed}
              onChange={(e) => patchDay(key, { close: e.target.value })}
              className="px-2 py-1.5 border border-gray-300 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed"
            />
          </div>
        );
      })}
    </div>
  );
};

export default OperatingHoursEditor;
